/**
 * @flow
 * @relayHash 5f796c0c60d4c78da90e042eb484ac75
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type ExperimentGroupAdExplanation = "DEFAULT" | "NONE" | "SHOW_EXPLANATION" | "%future added value";
export type ExperimentGroupAnonSignIn = "ANONYMOUS_ALLOWED" | "AUTHED_USER_ONLY" | "NONE" | "%future added value";
export type ExperimentGroupOneAdForNewUsers = "DEFAULT" | "NONE" | "ONE_AD_AT_FIRST" | "%future added value";
export type ExperimentGroupThirdAd = "NONE" | "THREE_ADS" | "TWO_ADS" | "%future added value";
export type ExperimentGroupVariousAdSizes = "NONE" | "STANDARD" | "VARIOUS" | "%future added value";
export type CreateNewUserInput = {
  userId: string,
  email?: ?string,
  referralData?: ?ReferralData,
  experimentGroups?: ?ExperimentGroups,
  extensionInstallId?: ?string,
  extensionInstallTimeApprox?: ?string,
  clientMutationId?: ?string,
};
export type ReferralData = {
  referringUser?: ?string,
  referringChannel?: ?string,
};
export type ExperimentGroups = {
  anonSignIn?: ?ExperimentGroupAnonSignIn,
  variousAdSizes?: ?ExperimentGroupVariousAdSizes,
  thirdAd?: ?ExperimentGroupThirdAd,
  oneAdForNewUsers?: ?ExperimentGroupOneAdForNewUsers,
  adExplanation?: ?ExperimentGroupAdExplanation,
};
export type CreateNewUserMutationVariables = {|
  input: CreateNewUserInput
|};
export type CreateNewUserMutationResponse = {|
  +createNewUser: ?{|
    +user: ?{|
      +id: string,
      +email: ?string,
      +username: ?string,
    |}
  |}
|};
export type CreateNewUserMutation = {|
  variables: CreateNewUserMutationVariables,
  response: CreateNewUserMutationResponse,
|};
*/


/*
mutation CreateNewUserMutation(
  $input: CreateNewUserInput!
) {
  createNewUser(input: $input) {
    user {
      id
      email
      username
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "input",
    "type": "CreateNewUserInput!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "createNewUser",
    "storageKey": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input",
        "type": "CreateNewUserInput!"
      }
    ],
    "concreteType": "CreateNewUserPayload",
    "plural": false,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "user",
        "storageKey": null,
        "args": null,
        "concreteType": "User",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "id",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "email",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "username",
            "args": null,
            "storageKey": null
          }
        ]
      }
    ]
  }
];
return {
  "kind": "Request",
  "operationKind": "mutation",
  "name": "CreateNewUserMutation",
  "id": null,
  "text": "mutation CreateNewUserMutation(\n  $input: CreateNewUserInput!\n) {\n  createNewUser(input: $input) {\n    user {\n      id\n      email\n      username\n    }\n  }\n}\n",
  "metadata": {},
  "fragment": {
    "kind": "Fragment",
    "name": "CreateNewUserMutation",
    "type": "Mutation",
    "metadata": null,
    "argumentDefinitions": v0,
    "selections": v1
  },
  "operation": {
    "kind": "Operation",
    "name": "CreateNewUserMutation",
    "argumentDefinitions": v0,
    "selections": v1
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'fc25db3c5643bbcf8e46d09732780fa3';
module.exports = node;



// WEBPACK FOOTER //
// ./src/js/mutations/__generated__/CreateNewUserMutation.graphql.js